import shoppingCartText from '@/api/shopping_cart_text'

export const getShoppingCartTextAPI = ({ commit, dispatch }, shippingId) => {
  return new Promise((resolve, reject) => {
    shoppingCartText.getShoppingCartText(result => {
      resolve(result.data.data)
    }, shippingId)
  })
}

export const setShoppingCartTextAPI = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    shoppingCartText.setShoppingCartText(result => {
      resolve(result.data.status)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/shopping_cart_text/actions.js